// src/utils/supabaseClient.js

import {
  createClient,
} from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env
    .VITE_SUPABASE_URL;

const supabasePublishableKey =
  import.meta.env
    .VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error(
    "Missing VITE_SUPABASE_URL environment variable."
  );
}

if (
  !supabasePublishableKey
) {
  throw new Error(
    "Missing VITE_SUPABASE_ANON_KEY environment variable."
  );
}

if (
  !supabaseUrl.startsWith(
    "https://"
  )
) {
  throw new Error(
    "VITE_SUPABASE_URL must use HTTPS."
  );
}

if (
  supabasePublishableKey.startsWith(
    "sb_secret_"
  )
) {
  throw new Error(
    "Security error: a Supabase secret key must never be used in browser code."
  );
}

export const supabase =
  createClient(
    supabaseUrl,
    supabasePublishableKey,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    }
  );